// extracted by mini-css-extract-plugin
export default {"table":"styles_table__Lm-8Q","tr":"styles_tr__pV69a","th":"styles_th__0Ea8F","td":"styles_td__s3w0Q","no_data_found":"styles_no_data_found__k8muU"};